exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.reservations-tabs__container[data-v-31c76cb2] {\n  margin-top: 1.5rem;\n}\n.micro-tabs[data-v-31c76cb2] {\n  margin: 0;\n  padding: 0;\n}\n.micro-tabs > li[data-v-31c76cb2] {\n    display: inline-block;\n    list-style: none;\n    margin-right: 0.5rem;\n    padding: 0.4rem 1rem;\n    color: #35495e;\n    background: #f7f8fa;\n    border: 1px solid rgba(0, 0, 0, 0.12);\n    border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n    border-top-left-radius: 6px;\n    border-top-right-radius: 6px;\n    cursor: pointer;\n}\n.micro-tabs > li.active[data-v-31c76cb2] {\n    font-weight: 600;\n    background: #ffffff;\n    border-color: rgba(0, 0, 0, 0.16);\n    border-bottom-color: transparent;\n    margin-bottom: -1px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-31c76cb2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reservations/ReservationsTabs.vue
// module id = 2782
// module chunks = 0